import { parsePx } from './parse-px';

export const parseGap = (gap) => {
  const parts = gap.trim().split(/\s+/);
  return parsePx(parts[parts.length - 1] ?? '');
};
